/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { ClusterAllocationMode } from '../types/common/AllocationMode';
import { getRandomId } from '../utils/getRandomId';

export const NOTISTACK_MAX_STACK = 3;
export const DEFAULT_CLUSTER_ALLOCATION_MODE: ClusterAllocationMode = ClusterAllocationMode.Plan;
export const PHOTO_ACCEPTABLE_FILES = 'image/png,image/jpg,image/webp';
export const MAX_PHOTO_FILE_SIZE_IN_BYTES = 500 * 1024; // 500 kbs

export const CLIENT_NAVIGATION_DRAWER_WIDTH = 260;
export const ADMIN_NAVIGATION_DRAWER_WIDTH = 260;

export const DATASET_DEFAULT_READONLY: boolean = true;

export const MIN_REPLICA_TIME_FOR_DOWNLOAD: number = 1;

export const CLUSTERGW_DEFAULT_DATABASE = 'cybertec'; // (process.env.REACT_APP_CLUSTERGW_DEFAULT_DATABASE as string) || "cybertec";

export const ORIENTATION_TO_ANGLE: { [key: number]: number } & {
  __fallback: number;
} = {
  3: 180,
  6: 90,
  8: -90,

  __fallback: 0,
};

export const IMPORT_CLUSTER_DATA_SETS_OVERLAY_CSS_ANCHOR = getRandomId('js-anchor-');
export const CREATE_CLUSTER_OVERLAY_CSS_ANCHOR = getRandomId('js-anchor-');

export const PUB_SUB_APP_CHANNEL = getRandomId('pub-sub-channel-');

export const REACT_APP_MAINTENANCE_TIME_FRAME = '00:00-23:59'; // (process.env.REACT_APP_MAINTENANCE_TIME_FRAME as string) || "00:00-23:59";

export const LINKS = {
  DOCUMENTATION: '/docs/',
};
